import React from 'react';
import Library from './Library';

import './Libraries.scss';

const Libraries = ({ libraries, eventID, handlePickItem }) => {
	return libraries && libraries.length ? (
		<div className="Libraries">
			{libraries.map(library => (
				<Library library={library} eventID={eventID} handlePickItem={handlePickItem} />
			))}
		</div>
	) : null;
};

export default Libraries;
